module.exports = __webpack_public_path__ + "static/media/download-icon.cc2a4fc1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/download-icon.svg
// module id = 1232
// module chunks = 21